import React, { useState } from "react";
import ReactTable from "react-table";
import "react-table/react-table.css";

const GenericReactTable = (props) => {
    const { data, columns, size, tablewidth, sortable, pagination, pagesize, enableRowHover, tableheight } = props;

    const [hoveredRow, setHoveredRow] = useState(null)
    return (
        <div>
            <ReactTable
                data={data}
                sortable={sortable}
                size={size}
                style={{
                    width: tablewidth,
                    height: tableheight
                }}
                showPagination={pagination}
                columns={columns}
                defaultPageSize={pagesize}
                getTrProps={(state, rowInfo, index) => {
                    if (rowInfo && rowInfo.row && enableRowHover) {
                        return {
                            onMouseEnter: (e) => {
                                setHoveredRow(rowInfo.index)
                            },
                            onMouseLeave: (e) => {
                                setHoveredRow(null)
                            },
                            style: {
                                background: rowInfo.index === hoveredRow ? '#efefef' : 'white',
                                cursor: "pointer"
                            }
                        }
                    } else return {}
                }}
            />
        </div>
    );
};

export default GenericReactTable;
